import constants from '../constants';

export function resetData() {
  return (dispatch) => {
    dispatch({ type: constants.RESET_DATA });
  };
}
